import { AuthService } from "./auth.service";
import { inject } from "@angular/core";

export function AuthGuard() {
  const authService = inject(AuthService);
  return authService.loggedIn;
};
